// src/components/Footer.js — Light Theme
import React, { useState } from 'react';
import styled from 'styled-components';
import { FaTwitter, FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo.png';

const GooglePlayIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path fill="#4CAF50" d="M491.4,244.2c-20.2-20.2-44.5-35.3-71.3-44.4L55.5,1.2C40-3.9,23.3,1.5,13.2,13.9c-9.9,12.2-9.9,28.9,0,41.1l111,136.2L124.2,321c-10.1,12.4-10.1,29.1,0,41.5c10.1,12.4,26.7,17.8,41.1,12.7l313.4-156.7C498.1,311.7,511.6,283.6,491.4,244.2z"/>
    <path fill="#FFC107" d="M13.2,498.1c-10.1-12.4-10.1-29.1,0-41.5L240.4,256L124.2,191.8L13.2,41.1C3.3,28.9,3.3,12.2,13.2,0c3.3,4.4,5.5,9.2,6.6,14.3l111,341.3L13.2,498.1z"/>
    <path fill="#F44336" d="M380.7,288.5L55.5,510.8c5,1.1,10.3,1.1,15.6,0l324-162c24.6-12.3,40-36.6,40-63.5c0-6.6-1.1-13.1-3.2-19.2L380.7,288.5z"/>
    <path fill="#2196F3" d="M380.7,223.5L325.2,256l55.5-22.3L491.8,170c-2.1-6.2-5.3-11.9-9.5-17.2L380.7,223.5z"/>
  </svg>
);

export const Footer = () => {
  const [copied, setCopied] = useState(false);
  const tokenAddress = '0xdD3f2d1B0EC5ea81CDf70e79C713D35EF8d530E1';

  const handleCopy = () => {
    navigator.clipboard?.writeText(tokenAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <FooterContainer>
      <ContentWrapper>
        <Grid>
          {/* LEFT: BRAND */}
          <InfoColumn>
            <LogoContainer>
              <LogoImage src={logoImage} alt="Trend Genie — Best AI Crypto Signals App" />
              <LogoText>Trend Genie</LogoText>
            </LogoContainer>

            <Description>
              The best free AI crypto signals app — combining real-time trade signals,
              DeFi safety scanning, Web3 social, and the $TGEN utility token in one
              complete ecosystem for traders and builders.
            </Description>

            <Tagline>
              Scan charts. Scan contracts. Trade smarter with AI.
            </Tagline>

            <SocialLinks>
              <SocialLink
                href="https://x.com/trendgenie_ai"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Trend Genie on X (Twitter)"
              >
                <FaTwitter size={18} />
              </SocialLink>
              <SocialLink
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Trend Genie GitHub"
              >
                <FaGithub size={18} />
              </SocialLink>
              <SocialLink
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Trend Genie LinkedIn"
              >
                <FaLinkedin size={18} />
              </SocialLink>
            </SocialLinks>

            <ButtonRow>
              <PlayStoreButton
                href="https://play.google.com/store/apps/details?id=com.entiresolutions.trendgenie"
                target="_blank"
                rel="noopener noreferrer"
              >
                <GooglePlayIcon style={{ width: '1.6rem', height: '1.6rem' }} />
                <div>
                  <span style={{ fontSize: '0.7rem', color: 'var(--text-muted)', display: 'block' }}>GET IT ON</span>
                  <span style={{ fontSize: '1rem', fontWeight: 700, color: 'var(--text-color)', display: 'block', marginTop: '-2px' }}>
                    Google Play
                  </span>
                </div>
              </PlayStoreButton>

              <WebAppButton
                href="https://app.trendgenie.io"
                target="_blank"
                rel="noopener noreferrer"
              >
                Open Web App
              </WebAppButton>
            </ButtonRow>
          </InfoColumn>

          {/* MIDDLE: LINKS */}
          <LinkColumn>
            <ColumnTitle>Explore</ColumnTitle>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li><FooterLink to="/">Home</FooterLink></li>
              <li><FooterLink to="/about">About</FooterLink></li>
              <li><FooterLink to="/pricing">Genie Social</FooterLink></li>
              <li><FooterLink to="/rewards">Rewards</FooterLink></li>
              <li><FooterLink to="/live-results">Live Results</FooterLink></li>
              <li><FooterLink to="/insights">Insights</FooterLink></li>
              <li><FooterLink to="/whitepaper">Whitepaper</FooterLink></li>
            </ul>
          </LinkColumn>

          {/* RIGHT: WEB3 + CONTACT */}
          <LinkColumn>
            <ColumnTitle>Web3 &amp; Tools</ColumnTitle>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li>
                <ExternalFooterLink
                  href="https://app.trendgenie.io"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  RugShield — DeFi Scanner
                </ExternalFooterLink>
              </li>
              <li>
                <FooterLink to="/token">$TGEN Utility Token</FooterLink>
              </li>
              <li>
                <FooterLink to="/whitepaper">Ecosystem &amp; Roadmap</FooterLink>
              </li>
              <li>
                <ExternalFooterLink
                  href="https://play.google.com/store/apps/details?id=com.entiresolutions.trendgenie"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Free Crypto Signals App
                </ExternalFooterLink>
              </li>
            </ul>

            <ColumnTitle style={{ marginTop: '1.5rem' }}>Contact</ColumnTitle>
            <ContactList>
              <ContactInfo>
                <FaEnvelope style={{ marginRight: '0.5rem', color: 'var(--text-muted)' }} />
                <ContactEmail href="mailto:contact@trendgenie.io">
                  contact@trendgenie.io
                </ContactEmail>
              </ContactInfo>
              <ContactInfo>
                <FaEnvelope style={{ marginRight: '0.5rem', color: 'var(--text-muted)' }} />
                <ContactEmail href="mailto:support@trendgenie.io">
                  support@trendgenie.io
                </ContactEmail>
              </ContactInfo>

              <TokenBlock>
                <TokenLabel>$TGEN Contract:</TokenLabel>
                <TokenAddress>{tokenAddress}</TokenAddress>
                <CopyButton type="button" onClick={handleCopy}>
                  {copied ? 'Copied!' : 'Copy address'}
                </CopyButton>
              </TokenBlock>
            </ContactList>
          </LinkColumn>
        </Grid>

        <Copyright>
          <p>&copy; {new Date().getFullYear()} Trend Genie. All rights reserved. The best free AI crypto signals app for Android.</p>
          <LegalLinks>
            <LegalLink to="/privacy-policy">Privacy Policy</LegalLink>
          </LegalLinks>
        </Copyright>
      </ContentWrapper>
    </FooterContainer>
  );
};

/* ---- STYLES ---- */

const FooterContainer = styled.footer`
  background: var(--bg-secondary);
  border-top: 1px solid var(--border-color);
`;

const ContentWrapper = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 3.5rem 1.5rem 2rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.5rem;
  margin-bottom: 2.5rem;

  @media (min-width: 768px) {
    grid-template-columns: 2fr 1fr 1.3fr;
  }
`;

const InfoColumn = styled.div`
  @media (min-width: 768px) {
    padding-right: 2rem;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

const LogoImage = styled.img`
  width: 2.2rem;
  height: 2.2rem;
  filter: drop-shadow(0 2px 8px rgba(41, 171, 226, 0.35));
`;

const LogoText = styled.span`
  font-size: 1.4rem;
  font-weight: 800;
  background: linear-gradient(135deg, #29ABE2, #F7941D);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const Description = styled.p`
  color: var(--text-secondary-color);
  margin-bottom: 0.75rem;
  max-width: 30rem;
  font-size: 0.92rem;
  line-height: 1.7;
`;

const Tagline = styled.p`
  color: var(--text-muted);
  font-size: 0.85rem;
  margin-bottom: 1.25rem;
  font-style: italic;
`;

const SocialLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
`;

const SocialLink = styled.a`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  background: var(--bg-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  transition: all 0.2s ease;
  box-shadow: var(--shadow-sm);

  &:hover {
    color: var(--primary-color);
    border-color: var(--primary-color);
    background: var(--primary-light);
    transform: translateY(-2px);
  }
`;

const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

const PlayStoreButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  background: var(--bg-surface);
  border: 1.5px solid var(--border-color);
  color: var(--text-color);
  font-weight: 600;
  padding: 0.65rem 1.1rem;
  border-radius: 12px;
  text-decoration: none;
  box-shadow: var(--shadow-sm);
  transition: all 0.25s ease;

  &:hover {
    border-color: var(--primary-color);
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }
`;

const WebAppButton = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 0.65rem 1.3rem;
  border-radius: 12px;
  font-weight: 700;
  text-decoration: none;
  font-size: 0.95rem;
  background: linear-gradient(135deg, #29ABE2, #1A5276);
  color: white;
  box-shadow: var(--shadow-primary);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-primary-lg);
  }
`;

const LinkColumn = styled.div``;

const ColumnTitle = styled.h4`
  color: var(--text-color);
  font-weight: 700;
  margin-bottom: 1rem;
  font-size: 0.85rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

const FooterLink = styled(Link)`
  color: var(--text-secondary-color);
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    color: var(--primary-color);
    transform: translateX(2px);
  }
`;

const ExternalFooterLink = styled.a`
  color: var(--text-secondary-color);
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    color: var(--primary-color);
    transform: translateX(2px);
  }
`;

const ContactList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ContactInfo = styled.li`
  display: flex;
  align-items: center;
  color: var(--text-secondary-color);
  font-size: 0.88rem;
  margin-bottom: 0.5rem;
`;

const ContactEmail = styled.a`
  color: var(--text-secondary-color);
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: var(--primary-color);
  }
`;

const TokenBlock = styled.li`
  color: var(--text-secondary-color);
  font-size: 0.85rem;
  margin-top: 1rem;
`;

const TokenLabel = styled.span`
  font-weight: 700;
  color: var(--text-color);
  display: block;
  margin-bottom: 0.3rem;
`;

const TokenAddress = styled.span`
  font-size: 0.72rem;
  word-break: break-all;
  display: block;
  color: var(--text-muted);
  font-family: 'SF Mono', 'Fira Code', monospace;
  background: var(--bg-tertiary);
  padding: 0.4rem 0.6rem;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  margin-bottom: 0.4rem;
`;

const CopyButton = styled.button`
  padding: 0.25rem 0.65rem;
  font-size: 0.72rem;
  border-radius: 999px;
  border: 1.5px solid var(--border-color);
  background: var(--bg-surface);
  color: var(--text-secondary-color);
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 600;

  &:hover {
    background: var(--primary-light);
    border-color: var(--primary-color);
    color: var(--primary-color);
  }
`;

const Copyright = styled.div`
  border-top: 1px solid var(--border-color);
  padding-top: 1.5rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.82rem;

  p {
    margin: 0 0 0.5rem;
  }
`;

const LegalLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
`;

const LegalLink = styled(Link)`
  color: var(--text-muted);
  font-size: 0.82rem;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: var(--primary-color);
  }
`;
